import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import Accordion from '../../../../foundation/components/Accordion';
import Icon from '../../../../foundation/components/Icon';
import { MenuCatalogModifierPropType, MenuCatalogModifierSetPropType } from '../../../types/menu-catalog';
import ModifierSetGrid from '../../ModifierSetGrid';
import './ModifierSetAccordion.css';
var defaultProps = {
  modifiers: [],
  displayDescription: false,
  displayMinMaxAllowed: false,
  defaultOpen: false
};
export default function ModifierSetAccordion(_ref) {
  var modifierSet = _ref.modifierSet,
    modifiers = _ref.modifiers,
    displayDescription = _ref.displayDescription,
    displayMinMaxAllowed = _ref.displayMinMaxAllowed,
    defaultOpen = _ref.defaultOpen;
  var _useState = useState(defaultOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  function onAccordionClick() {
    setIsOpen(function (previousIsOpen) {
      return !previousIsOpen;
    });
  }
  var name = modifierSet.name;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion.Title, {
    active: isOpen,
    onClick: onAccordionClick
  }, /*#__PURE__*/React.createElement("span", null, name), " ", /*#__PURE__*/React.createElement(Icon, {
    iconName: isOpen ? 'minus' : 'plus'
  })), /*#__PURE__*/React.createElement(Accordion.Content, {
    active: isOpen
  }, /*#__PURE__*/React.createElement(ModifierSetGrid, {
    modifierSet: modifierSet,
    modifiers: modifiers,
    displayDescription: displayDescription,
    displayMinMaxAllowed: displayMinMaxAllowed
  })));
}
ModifierSetAccordion.defaultProps = defaultProps;